var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    {
      staticClass:
        "text-center py-0 d-flex flex-column justify-center align-center",
      style: { minHeight: _vm.minHeight },
    },
    [
      _c(
        "div",
        { class: _vm.minHeight === "calc(100vh - 300px)" ? "mt-10" : "" },
        [
          _c("img", {
            attrs: {
              contain: "",
              height: _vm.height,
              src: require(`@/assets/empty-state/appAsset--${_vm.type}-ax.svg`),
            },
          }),
          _c("div", { class: _vm.customClass }, [
            !_vm.isFree
              ? _c(
                  "span",
                  { staticClass: "d-block subtitle-2 grey-700--text" },
                  [
                    _c("span", { staticClass: "d-block font-weight-bold" }, [
                      _vm._v(
                        _vm._s(
                          !_vm.isFilter
                            ? `¿Quieres ver ${
                                _vm.id.includes("procesos") ? "los" : ""
                              } ${_vm.id}?`
                            : `No ${
                                _vm.id.includes("procesos") ? "hay" : "existen"
                              } ${_vm.id} para mostrar`
                        )
                      ),
                    ]),
                    _vm.hiddenDescription
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              !_vm.isFilter
                                ? "Filtra para obtener registros"
                                : "Modifica los filtros para obtener registros"
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              : _c(
                  "span",
                  { staticClass: "d-block subtitle-2 grey-500--text" },
                  [
                    _c("span", { staticClass: "d-block font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                    _vm._v(" " + _vm._s(_vm.description) + " "),
                  ]
                ),
          ]),
          _c("div", { staticClass: "mt-5" }, [_vm._t("actions")], 2),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }